import React, {useState} from 'react'
import {FormattedMessage} from 'react-intl'
import {FaPinterest, FaInstagram, FaLink} from 'react-icons/fa'
import {FaXTwitter} from 'react-icons/fa6'
import {AiFillFacebook} from 'react-icons/ai'
import {
    Box,
    IconButton,
    Input,
    Text,
    Alert,
    AlertTitle,
    Divider,
    List,
    ListItem
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {productUrlBuilder} from '../../utils/url'

const SocialSharingIcons = (product) => {
    const appOrigin = useAppOrigin()

    const [showCopyMessage, setShowCopyMessage] = useState(false)

    const handleCopy = () => {
        navigator.clipboard
            .writeText(productUrl)
            .then(() => {
                setShowCopyMessage(true)
                setTimeout(() => setShowCopyMessage(false), 3000)
            })
            .catch((err) => {
                console.error('Failed to copy text to clipboard: ', err)
            })
    }

    const escapedProductName = encodeURIComponent(product?.product?.name)
    const prodObj = {
        productName: product?.product?.name,
        productId: product?.product?.id
    }
    const productUrl = `${appOrigin}${productUrlBuilder(prodObj)}`
    const productImageLarge = encodeURIComponent(
        product?.product?.imageGroups?.find((item) => item.viewType === 'large')?.images[0]?.link
    )

    function announce(message) {
        const liveRegion = document.getElementById('aria-live-region')
        if (liveRegion) {
            liveRegion.textContent = ''
            setTimeout(() => {
                liveRegion.textContent = message
            }, 50)
        }
    }

    return (
        <>
            <Divider
                borderWidth="1px"
                borderColor="black"
                borderStyle="solid"
                opacity={'1'}
                my={4}
                display={{base: 'inherit', sm: 'none'}}
            />
            <Box
                className="social-container-pdp"
                display={'flex'}
                alignItems={'center'}
                justifyContent={{base: 'center', md: 'left'}}
                mt={{base: '0', lg: '3'}}
            >
                <Text as={'h3'} fontWeight="800" fontSize={'xl'} lineHeight={'1.75rem'} mr={2}>
                    <FormattedMessage id="social_share_heading" defaultMessage="Share" />
                </Text>

                <List className="social-icons" display={'flex'}>
                    <ListItem>
                        <IconButton
                            as="a"
                            href={`https://pinterest.com/pin/create/button/?url=${productUrl}&description=${escapedProductName}&media=${productImageLarge}`}
                            aria-label="Share on Pinterest"
                            icon={<FaPinterest style={{width: '24px'}} />}
                            variant="ghost"
                            target="_blank"
                            onMouseEnter={() => announce('Share on Pinterest')}
                        />
                    </ListItem>
                    <ListItem>
                        <IconButton
                            as="a"
                            href={`https://www.facebook.com/share.php?u=${productUrl}`}
                            aria-label="Share on Facebook"
                            icon={<AiFillFacebook />}
                            variant="ghost"
                            target="_blank"
                            onMouseEnter={() => announce('Share on Facebook')}
                        />
                    </ListItem>

                    <ListItem>
                        <IconButton
                            as="a"
                            href={`https://www.x.com/share.php?u=${productUrl}`}
                            aria-label="Share on X"
                            icon={<FaXTwitter />}
                            variant="ghost"
                            target="_blank"
                            onMouseEnter={() => announce('Share on X')}
                        />
                    </ListItem>
                    <ListItem>
                        <IconButton
                            as="a"
                            href={`https://instagram.com/share?url=${productUrl}&text=${product?.product?.name}`}
                            aria-label="Share on Instagram"
                            icon={<FaInstagram />}
                            variant="ghost"
                            target="_blank"
                            onMouseEnter={() => announce('Share on Instagram')}
                        />
                    </ListItem>
                    <ListItem>
                        <IconButton
                            onClick={handleCopy}
                            aria-label="Copy link"
                            icon={
                                <FaLink style={{width: '24px', height: 'auto', color: 'black'}} />
                            }
                            variant="ghost"
                            onMouseEnter={() => announce('Copy link')}
                        />
                    </ListItem>
                </List>

                <div
                    id="aria-live-region"
                    style={{position: 'absolute', left: '-9999px'}}
                    aria-live="polite"
                ></div>

                <Input type="hidden" id="shareUrl" value={productUrl} />

                {showCopyMessage && (
                    <Alert status="success" mt={4} borderRadius="md">
                        <AlertTitle>
                            <FormattedMessage
                                defaultMessage="The link to {productName} has been copied"
                                id="pdp_copy_product_link.toast"
                                values={{
                                    productName: product?.product?.name
                                }}
                            />
                        </AlertTitle>
                    </Alert>
                )}
            </Box>
        </>
    )
}

export default SocialSharingIcons
